import React from 'react';
import "./TrailerModal.scss";
import Video from '../../../UI/Video';

import videoTrailers from "../../../../utils/trailer";

interface UModalTrailerProps {
  video: string;
  type: string;
}

const TrailerModal = (props: UModalTrailerProps) => {
  const { type, video } = props;
  const trailer = type === "youtube" ? (
    <iframe
      width="100%"
      src={video.trim() + "?autoplay=1"}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="u-modal__content__iframe"
      title="Ubisoft Forward Trailer"
    />
  ) : (
    <Video nativeProps={{ controls: true, style: { width: '100%', height: '100%' }}} muted={false}>
      {videoTrailers.map(trailer => {
        const staticLinkedInput = document.querySelector(`input[data-video-id="${trailer.id}"]`);
        return (
          <source
            src={staticLinkedInput ? staticLinkedInput.getAttribute('data-video-src') : trailer.path}
            data-video-id={trailer.id}
            type={trailer.type}
            media={trailer.mediaQuery}
            key={trailer.id}
          />
        )
      })}
    </Video>
  );
  return (
    <div className="trailer">
      <div className="video-container">
        {trailer}
      </div>
    </div>
  );
};

export default TrailerModal;
